var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagerBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-manager_badge"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "manager_badge",
    clipPath: "url(#clip-manager_badge)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9270",
    "data-name": "Group 9270",
    transform: "translate(-446 -680)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bookmark",
    d: "M105.547,0H97.917A1.825,1.825,0,0,0,96.01,1.73V16.267a.365.365,0,0,0,.381.347.4.4,0,0,0,.271-.1l5.071-4.6,5.07,4.6a.41.41,0,0,0,.539,0,.331.331,0,0,0,.112-.245V1.73A1.825,1.825,0,0,0,105.547,0Z",
    transform: "translate(353.079 681)",
    fill: "#20bead"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21143",
    "data-name": "Path 21143",
    d: "M199.038,138.937l.939,1.9,2.1.3-1.519,1.481.359,2.091-1.877-.987-1.877.987.359-2.091L196,141.144l2.1-.3Z",
    transform: "translate(255.896 545.094)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerBadge);
export default __webpack_public_path__ + "static/media/manager_badge.ffb790a487ed9da22ace8ca7e0563299.svg";
export { ForwardRef as ReactComponent };